export function hitPixel(url) {
    try {
        fetch(url);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Error sending pixel : ${e}`);
    }
}
